import { MainTabsV2 } from '@labrav/react-components'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { useTenantPartnerId, useUserType, usePartner } from '@labrav/common'
import { settingsTabs } from '../FlyOutOnboardingWrapper/settingsTabs'
import { useSyncFlyoutRouteParams } from '../../common/utils/hooks/useSyncFlyoutRouteParams'
import { useStyles } from './ResellerAuthorizations.styles'
import { ReceivedResellerAuthorizations } from './ReceivedResellerAuthorizations/ReceivedResellerAuthorizations'
import { ResaleAuthorizationsWrapperUIV2 } from '../ResaleAuthorizationWrapperUIV2'
import type { ResellerAuthorizationsProps } from './types'

export type { ResellerAuthorizationsProps }

export const ResellerAuthorizations = (
  resellerAuthorizationProps: ResellerAuthorizationsProps
) => {
  useSyncFlyoutRouteParams(!!resellerAuthorizationProps.externalBaseURL)

  const tenantPartnerId = useTenantPartnerId()
  const partnerUser = useUserType()
  const { classes } = useStyles()
  const { partnerData } = usePartner(tenantPartnerId || '', partnerUser)

  const partnershipType = (
    partnerData as { partnershipType?: string | string[] } | null
  )?.partnershipType
  const isCP = partnershipType?.includes('CONSULTING_PARTNER')

  const defaultTabs = [
    ...(isCP
      ? [
          {
            key: 'reseller-authorizations-received',
            label: 'Received',
            path: 'received',
            renderElement: (
              <div data-testid={'received-content'}>
                <ReceivedResellerAuthorizations
                  {...resellerAuthorizationProps}
                />
              </div>
            ),
          },
        ]
      : []),
    {
      key: 'reseller-authorizations-sent',
      label: 'Sent',
      path: 'sent',
      renderElement: (
        <div data-testid={'sent-content'}>
          <ResaleAuthorizationsWrapperUIV2 {...resellerAuthorizationProps} />
        </div>
      ),
    },
  ]

  const {
    defaultSettingsTabs,
    activeTab,
    handleTabChange,
    settingsTabsForRouting,
  } = settingsTabs([], defaultTabs, true)

  return (
    <div className={classes.root}>
      {isCP && (
        <div className={classes.tabContainer}>
          <MainTabsV2
            tabs={defaultSettingsTabs}
            activeTabIndex={activeTab}
            onChange={handleTabChange}
            tabsType={'main'}
          />
        </div>
      )}
      <div className={classes.content}>
        <Suspense fallback={<div />}>
          <Routes>
            {settingsTabsForRouting.map(t => {
              return (
                <Route
                  key={t.path}
                  path={t.path}
                  element={t.renderElement ? t.renderElement : <></>}
                />
              )
            })}
          </Routes>
        </Suspense>
      </div>
    </div>
  )
}
